import gql from "graphql-tag";

export const getUsersQuery = gql(`
    query GetUsers {
        getUsers {
            id
            email
            fullName
            role
            organizations
        }
    }
`);

export const createManagedUserMutation = gql(`
    mutation CreateManagedUser($email: String!, $fullName: String, $role: String, $organizations: [String!]) {
        createManagedUser(email: $email, fullName: $fullName, role: $role, organizations: $organizations) {
            id
            email
            fullName
            role
            organizations
        }
    }
`);

export const updateManagedUserMutation = gql(`
    mutation UpdateManagedUser($id: String!, $email: String, $fullName: String, $role: String, $organizations: [String!]) {
        updateManagedUser(id: $id, email: $email, fullName: $fullName, role: $role, organizations: $organizations) {
            id
            email
            fullName
            role
            organizations
        }
    }
`);

export const deleteManagedUserMutation = gql(`
    mutation DeleteManagedUser($id: String!) {
        deleteManagedUser(id: $id) {
            message
        }
    }
`);

export const getMyAreaEditorSettingsQuery = gql(`
    query GetMyAreaEditorSettings($areaId: String!) {
        getMyAreaEditorSettings(areaId: $areaId) {
            areaId
            mapVisible
        }
    }
`);

export const setMyAreaEditorSettingsMutation = gql(`
    mutation SetMyAreaEditorSettings($areaId: String!, $mapVisible: Boolean!) {
        setMyAreaEditorSettings(areaId: $areaId, mapVisible: $mapVisible) {
            areaId
            mapVisible
        }
    }
`);
